import api from "./ApiInventoryConfig"


export const InventoryApi =  {
    getDevice:function(id: number)
    {
        return api.get(`/computer/${id}`)
    },
    getDeviceList:function(){
        return api.get('/computers?start=0&limit=10')
    }

}